import createLazyComponent from '../LazyComponent';

const DomainRegistrationWrapper = createLazyComponent(() => import('./DomainRegistrationWrapperPage'));

export default DomainRegistrationWrapper;
